"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var odc_help_tips_1 = __importDefault(require("@tencent/odc-help-tips"));
var spaui_1 = require("@tencent/spaui");
var Text = function Text(props, ref) {
  var _a, _b;
  var children = props.children,
    label = props.label,
    type = props.type,
    size = props.size,
    _c = props.as,
    as = _c === void 0 ? 'span' : _c,
    title = props.title,
    _d = props.block,
    block = _d === void 0 ? false : _d,
    _e = props.inlineBlock,
    inlineBlock = _e === void 0 ? false : _e,
    _f = props.nowrap,
    nowrap = _f === void 0 ? false : _f,
    lineClamp = props.lineClamp,
    style = props.style,
    prefix = props.prefix,
    suffix = props.suffix,
    icon = props.icon,
    endIcon = props.endIcon,
    tips = props.tips,
    _g = props.iconSize,
    iconSize = _g === void 0 ? 16 : _g,
    endIconClassName = props.endIconClassName,
    _h = props.needGap,
    needGap = _h === void 0 ? true : _h,
    opacity = props.opacity,
    _j = props.usePopOver,
    usePopOver = _j === void 0 ? false : _j,
    helpTipsProps = props.helpTipsProps,
    _k = props.PopOverProps,
    popProps = _k === void 0 ? {} : _k,
    _l = props.OverlayTriggerProps,
    overlayProps = _l === void 0 ? {
      placement: 'top'
    } : _l,
    restProps = __rest(props, ["children", "label", "type", "size", "as", "title", "block", "inlineBlock", "nowrap", "lineClamp", "style", "prefix", "suffix", "icon", "endIcon", "tips", "iconSize", "endIconClassName", "needGap", "opacity", "usePopOver", "helpTipsProps", "PopOverProps", "OverlayTriggerProps"]);
  var _m = __read(react_1["default"].useState(false), 2),
    ellipsis = _m[0],
    setEllipsis = _m[1];
  var textRef = react_1["default"].useRef(null);
  var nTitle = title;
  if (!title) {
    if (typeof label === 'string') {
      nTitle = label;
    }
    if (typeof children === 'string') {
      nTitle = children;
    }
  }
  var dom = label || children;
  react_1["default"].useImperativeHandle(ref, function () {
    var frameNode;
    return (frameNode = textRef.current) === null || frameNode === void 0 ? void 0 : frameNode;
  }, [textRef]);
  (0, react_1.useEffect)(function () {
    var textNode = textRef.current;
    if (textNode) {
      if (nowrap) {
        setEllipsis(textNode.scrollWidth > textNode.clientWidth);
      }
      if (lineClamp) {
        setEllipsis(textNode.scrollHeight > textNode.clientHeight);
      }
    }
  }, [textRef, nowrap, lineClamp, label, children]);
  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, restProps, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-text', (_a = {}, _a["odc-text-".concat(size)] = size !== 'none' && size, _a["odc-text-".concat(type)] = type, _a.ellipsis = nowrap, _a['odc-line-clamp'] = lineClamp, _a['inline-block'] = inlineBlock, _a['has-icon'] = icon, _a['has-tips'] = tips, _a['has-end-icon'] = endIcon, _a["opacity-".concat(opacity)] = typeof opacity === 'number', _a['has-ellipsis'] = ellipsis, _a)),
    supportAllEvents: true,
    ref: textRef
  }, Text), {
    title: !usePopOver && ellipsis ? nTitle : title,
    style: __assign((_b = {}, _b['--odc-line-clamp'] = lineClamp, _b), style),
    as: as,
    block: block,
    useClassName: false
  }), prefix, icon ? react_1["default"].createElement("i", {
    className: (0, classnames_1["default"])('odc-text-icon odc-text-custom-icon', {
      'mr-4': needGap
    }),
    style: {
      width: iconSize
    }
  }, icon) : null, dom, tips ? react_1["default"].createElement(odc_help_tips_1["default"], __assign({
    className: "odc-text-icon",
    inline: needGap,
    tips: tips,
    valign: 'top'
  }, helpTipsProps)) : null, suffix, endIcon ? react_1["default"].createElement(react_1["default"].Fragment, null, needGap ? ' ' : null, react_1["default"].createElement("i", {
    className: (0, classnames_1["default"])('odc-text-icon odc-text-end-icon', endIconClassName)
  }, endIcon)) : null, usePopOver && ellipsis ? react_1["default"].createElement(spaui_1.OverlayTrigger, __assign({
    overlay: react_1["default"].createElement(spaui_1.PopOver, __assign({
      children: dom
    }, popProps)),
    triggerTarget: textRef.current
  }, overlayProps)) : null);
};
(0, spaui_utils_1.setComponentMark)(Text, info_1["default"]);
exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(Text));